import { lazy } from 'react';
import withSuspense from '../../../../../helpers/withSuspense.jsx';
import InputSkeleton from '../../../../../skeleton_loaders/common/InputSkeleton.jsx';

const ChartTypeSettings = withSuspense(lazy(() => import('./ChartTypeSettings.jsx')), <InputSkeleton />);

export default ChartTypeSettings;